import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiMinus, FiPlus, FiTrash2 } from "react-icons/fi";
import siteConfig from "../siteConfig";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();
  const shipping = siteConfig.shippingRate;

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <div className="cart-page__empty-box">
            <p className="empty-kicker">NOTHING HERE—YET</p>
            <h2>Your cart is empty</h2>
            <p>There are so many colorful little goodies waiting for you.</p>

            <Link
              to="/shop"
              onClick={toTop}
              className="cart-page__continue-btn"
            >
              Shop all goodies
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <main className="cart-page__main">
        <div className="cart-page__left">
          <p className="cart-kicker">YOUR PICKS</p>
          <h1 className="cart-title">Your cart</h1>

          <div className="cart-items">
            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              const linePrice = (Number(product.price) * item.quantity).toFixed(
                2
              );
              return (
                <div
                  className="cart-item"
                  key={`${item.id}-${item.size}-${item.color}`}
                >
                  <div className="cart-item__thumb">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-item__info">
                    <div className="cart-item__vendor">{product.brand}</div>
                    <div className="cart-item__name">{product.name}</div>
                    <div className="cart-item__meta">
                      <span>Color : {item.color}</span>
                      <span> | </span>
                      <span>Size : {item.size}</span>
                    </div>

                    <div className="cart-item__actions">
                      <button
                        className="cart-action"
                        onClick={() =>
                          removeFromCart(item.id, item.size, item.color)
                        }
                      >
                        <FiTrash2 /> Remove
                      </button>
                    </div>
                  </div>
                  <div className="cart-item__price">
                    <div className="qty-controls">
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                      >
                        <FiMinus />
                      </button>
                      <span className="qty">{item.quantity}</span>
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                      >
                        <FiPlus />
                      </button>
                    </div>
                    <div className="line-total">
                      ${Number(linePrice).toFixed(2)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-continue">
            <Link
              to="/shop"
              onClick={toTop}
              className="cart-page__continue-btn"
            >
              <FiArrowLeft /> Continue shopping
            </Link>
          </div>
        </div>

        <aside className="cart-page__right">
          <div className="summary">
            <div className="summary-row">
              <span>Subtotal</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>
            <div className="summary-row"><span>Estimated shipping</span><span>{shipping === 0 ? "FREE" : `$${shipping.toFixed(2)}`}</span></div>

            <div className="summary-total">
              <div className="label">
                Estimated total
                <small>Taxes calculated at checkout</small>
              </div>
              <div className="amount">
                ${(subtotal + shipping).toFixed(2)} USD
              </div>
            </div>

            <button className="place-order" onClick={handleCheckout}>
              Check out
            </button>
          </div>
        </aside>
      </main>
    </div>
  );
};

export default CartPage;
